import { render, staticRenderFns } from "./navEditer.vue?vue&type=template&id=6be2fe08&scoped=true"
import script from "./navEditer.vue?vue&type=script&lang=js"
export * from "./navEditer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be2fe08",
  null
  
)

export default component.exports